import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Key, X, Check } from 'lucide-react';

const CompanyPermissionsEditor = ({
  userId,
  userName,
  availableApps,
  selectedPermissions,
  onToggle,
  onSave,
  onCancel,
  loading
}) => {
  return (
    <Card className="bg-accent-light/20 border-2 border-accent rounded-2xl p-6 mb-6 animate-scale-in">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
            <Key className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </div>
          <h4 className="text-lg font-semibold text-foreground">
            Gestionare Permisiuni - {userName}
          </h4>
        </div>
        <div className="flex gap-2">
          <Button
            size="sm"
            variant="ghost"
            onClick={onCancel}
            className="rounded-xl"
            data-testid="company-permissions-cancel"
          >
            <X className="w-4 h-4 mr-1" />
            Anulează
          </Button>
          <Button
            size="sm"
            variant="premium"
            onClick={() => onSave(userId)}
            disabled={loading}
            className="rounded-xl"
            data-testid="company-permissions-save"
          >
            <Check className="w-4 h-4 mr-1" />
            Salvează
          </Button>
        </div>
      </div>

      <div className="space-y-3">
        <p className="text-sm text-muted-foreground mb-4">
          Selectează aplicațiile din Company Area la care utilizatorul va avea acces:
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {availableApps.map((app) => (
            <div
              key={app.id}
              onClick={() => onToggle(app.id)}
              className={`p-3 rounded-xl border-2 cursor-pointer transition-all duration-200 ${
                selectedPermissions.includes(app.id)
                  ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                  : 'border-border hover:border-blue-300 dark:hover:border-blue-700'
              }`}
              data-testid={`company-perm-${app.id}`}
            >
              <div className="flex items-center gap-3">
                <div className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                  selectedPermissions.includes(app.id)
                    ? 'border-blue-500 bg-blue-500'
                    : 'border-muted-foreground'
                }`}>
                  {selectedPermissions.includes(app.id) && (
                    <Check className="w-3 h-3 text-white" />
                  )}
                </div>
                <span className="font-medium text-foreground">{app.name}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl">
          <p className="text-sm text-muted-foreground">
            <strong>Aplicații selectate:</strong> {selectedPermissions.length} din {availableApps.length}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default CompanyPermissionsEditor;
